import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";
import { VscHistory } from "react-icons/vsc";
import addPrecision from "../../common/addPrecision";
import AppButton from "../../common/AppButton";
import AppModal from "../../common/AppModal";
import Table from "../../common/Table";
import Body from "../../components/Body";
import TableMenu from "../../components/TableMenu";
import useHeader from "../../hooks/useHeader";
import useJob from "../../hooks/useJob";
import PaymentsLogModel from "../jobs/PaymentsLogModel";
import InvoiceToggles from "./InvoiceToggles";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { getJobs } from "../../stores/JobStore";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getPosGroupedByJob } from "../../stores/PoStore";
import { getLocations } from "../../stores/LocationStore";
import { getOrganizations } from "../../stores/OrganizationStore";
import { getPaymentsGroupedByJob } from "../../stores/PaymentStore";

const header = [
  { name: "invoiceID", title: "invoice ID", filter: "Search" },
  { name: "organization", title: "Client", filter: "Search" },
  {
    name: "location",
    title: "Location",
    trunecate: true,
    filter: "Search",
  },
  { name: "poNo", title: "PO No", filter: "Search" },
  { name: "amount", title: "Amount" },
];

const LIMIT = 100;
function InvoicePaid() {
  const job = useJob();
  const location = useLocation();
  const navigate = useNavigate();
  const { setHeader } = useHeader();
  const [model, setModel] = useState({});
  const PLog = PaymentsLogModel();
  const [loadingMore, setLoadingMore] = useState(false);

  const [skip, setSkip] = useState(LIMIT);
  const { data: jobs, refetch } = useQuery({
    queryFn: () => getJobs({ invoiceCreated: true, limit: skip }),
    queryKey: ["jobs", LIMIT],
  });

  console.log(jobs?.length);

  const { data: posGroupedByJob } = useQuery({
    queryFn: () => getPosGroupedByJob(),
    queryKey: ["pos", "groupedByJob"],
  });

  const { data: locationsData } = useQuery({
    queryFn: () => getLocations(),
    queryKey: ["locations"],
  });

  const { data: organizations } = useQuery({
    queryFn: () => getOrganizations(),
    queryKey: ["organizations"],
  });

  const { data: paymentsGroupedByJob } = useQuery({
    queryFn: () => getPaymentsGroupedByJob(),
    queryKey: ["jobPayments", "groupedByJob"],
  });

  useEffect(() => {
    setHeader("Invoices");
  }, []);

  const handleLoadMore = async () => {
    setLoadingMore(true);
    setSkip(skip + LIMIT);
  };

  useEffect(() => {
    refetch();
    setLoadingMore(false);
  }, [skip]);
  // const load = async () => {
  //   const res = await api.get("jobs", { invoiceCreated: true });
  //   if (!res.ok) {
  // return toast.error(res.originalError.message);
  //   }

  //   const list = res.data.filter((jb) => {
  //     return job.paymentStatus({ job: jb }) === "Completed";
  //   });
  //   setList(list);
  // };
  // const list = jobStore.jobs?.filter((jb) => {
  //   if (jb.invoiceCreated !== true) return false;
  //   return job.paymentStatus({ job: jb }) === "Completed";
  // });

  const data = jobs
    ?.map((jb) => {
      const pos = posGroupedByJob?.[jb._id];
      console.log(pos);
      const po = pos ? pos[pos.length - 1] : undefined;
      const locations = jb?.location?.map((loc) => {
        const found = locationsData?.find((item) => item._id === loc);
        return found;
      });
      return {
        ...jb,
        organization: organizations?.find((i) => i._id === jb.organization)
          ?.name,
        amount: `$ ${addPrecision(jb.total)}`,
        location: `${locations
          ?.filter((i) => i)
          ?.map((i) => i.title)
          .join(", ")}`,
        poNo: po?.poNo || " - ",
        payments: paymentsGroupedByJob?.[jb._id],
      };
    })
    .filter((i) => {
      return job.paymentStatus({ job: i }) === "Completed";
    });

  return (
    <React.Fragment>
      <Body noPadding>
        <div style={{ flex: 1 }}>
          {/* <SearchInput spinning={spinning} onSubmit={handleSearch} /> */}
          <TableMenu
            className="d-flex"
            style={{ width: 60, justifyContent: "space-between" }}
          >
            <InvoiceToggles />
          </TableMenu>
          <Table
            countNumber={false}
            loading={!data}
            header={header}
            data={data || []}
            SideButtons={({ inv }) => {
              return (
                <div className="side-button">
                  <AppButton
                    leftIcon={<FaEye />}
                    tooltip="View"
                    className="text-primary "
                    onClick={() => {
                      const { pathname } = location;
                      navigate(pathname + "/invoiceToPdf", {
                        state: { data: cloneDeep(inv) },
                        noSettings: true,
                      });
                    }}
                  />
                  <AppButton
                    tooltip="Payments Log"
                    className="text-primary"
                    onClick={() => {
                      setModel({
                        visible: true,
                        header: <PLog.Header invoiceId={inv.invoiceId} />,
                        body: <PLog.Body payments={inv.payments} />,
                      });
                    }}
                    leftIcon={<VscHistory />}
                  />
                  {/* <AppButton
                  tooltip="Delete"
                  className="text-primary"
                  onClick={() => handleDelete(inv)}
                  leftIcon={<BiTrash />}
                /> */}
                </div>
              );
            }}
          />
        </div>
      </Body>
      <AppModal
        onHide={() => {
          setModel({});
        }}
        {...model}
      />
      {data?.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 20,
          }}
        >
          <AppButton
            onClick={handleLoadMore}
            text="Load more..."
            className="btn-secondary"
            disabled={loadingMore}
          />
        </div>
      )}
    </React.Fragment>
  );
}
export default observer(InvoicePaid);
